import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareTimelineEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-software-timeline-entrypoint" */ './next-gen'),
	),
	getPreloadProps: () => ({}),
});
